import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const CompetitionSsrPage = lazy(() => import("./competitionSsr"));

export const competitionPageSsrProps = {
    ssrEnabled: true,
    ssrComponent: (ssrProps: any) => <CompetitionSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <CompetitionSsrPage {...ssrProps} />,
}

export const competitionPageSsrEnabledProps = {
    ...competitionPageSsrProps,
    ssrEnabled: true,
}
import { lazy } from "react";
import { ssrGetInitData } from "./getInitData";
import { getHeadTemplate } from "./getHeadTemplate";
import { ssrGetPageTemplate } from "./ssrGetPageTemplate";

const CompetitionSsrPage = lazy(() => import("./competitionSsr"));

export const competitionPageSsrProps = {
    ssrEnabled: true,
    ssrComponent: (ssrProps: any) => <CompetitionSsrPage {...ssrProps} />,
    ssrGetHeadTemplate: getHeadTemplate,
    ssrGetInitData,
    ssrGetPageTemplate,
    ssrOptions: {},
    notFoundComponent: (ssrProps: any) => <CompetitionSsrPage {...ssrProps} />,
}

export const competitionPageSsrEnabledProps = {
    ...competitionPageSsrProps,
    ssrEnabled: true,
}
